module.exports = __webpack_public_path__ + "img/02-02-img-01.8fa1684c.png";